import { g } from '../other/function.js';

(function () {
  const form = g('.fn_validate_cart');
  if (!form) return;

  const phoneInput = g('#phone-input');
  const nameInput = g('#name-input');
  const lastnameInput = g('#lastname-input');
  const emailInput = g('#email-input');
  const cityInput = g('#your-city');
  const streetInput = g('#your-addres-str');
  const homeInput = g('#your-addres-home');
  const novaInput = g('#your-nova');
  const novaBoxInput = g('#your-nova-box');

  const deliverySection = g('.order-new-section__delivery');
  const paySection = g('.order-new-section__pay');

  function ensureGroupError(section, id) {
    if (!section) return null;
    let el = section.querySelector('.message_error');
    if (!el) {
      el = document.createElement('div');
      el.className = 'message_error';
      el.id = id;
      el.style.display = 'none';
      const span = document.createElement('span');
      el.appendChild(span);
      section.appendChild(el);
    }
    return el;
  }

  const deliveryError = ensureGroupError(deliverySection, 'delivery-group-error');
  const payError = ensureGroupError(paySection, 'pay-group-error');

  function showGroupError(el, msg) {
    if (!el) return;
    const span = el.querySelector('span') || el;
    span.textContent = msg;
    el.style.display = '';
  }

  function hideGroupError(el) {
    if (!el) return;
    el.style.display = 'none';
  }

  function markRed(input) {
    if (!input) return;
    input.classList.add('error');
    input.setAttribute('aria-invalid', 'true');
  }

  function unmarkRed(input) {
    if (!input) return;
    input.classList.remove('error');
    input.removeAttribute('aria-invalid');
  }

  function setError(input, msg) {
    if (!input) return;
    const id = input.getAttribute('aria-describedby');
    const err = id ? document.getElementById(id) : null;
    if (err) err.textContent = msg;
    input.setAttribute('aria-invalid', 'true');
  }

  function clearErr(input) {
    if (!input) return;
    const id = input.getAttribute('aria-describedby');
    const err = id ? document.getElementById(id) : null;
    if (err) err.textContent = '';
    input.removeAttribute('aria-invalid');
  }

  function isPhoneValid() {
    return (phoneInput?.value.replace(/\D/g, '').length ?? 0) >= 12;
  }

  function isContactConfirmed() {
    return g('.order-new-section__contact')?.classList.contains('active');
  }

  function validateDelivery() {
    const selected = form.querySelector('input[name="delivery_id"]:checked');

    if (!selected) {
      unmarkRed(streetInput);
      unmarkRed(homeInput);
      unmarkRed(novaInput);
      unmarkRed(novaBoxInput);
      showGroupError(deliveryError, 'Виберіть спосіб доставки');
      return false;
    }

    const val = selected.value;

    if (val === '1') {
      let ok = true;
      if (!streetInput?.value.trim()) {
        markRed(streetInput);
        ok = false;
      } else {
        unmarkRed(streetInput);
      }
      if (!homeInput?.value.trim()) {
        markRed(homeInput);
        ok = false;
      } else {
        unmarkRed(homeInput);
      }
      unmarkRed(novaInput);
      unmarkRed(novaBoxInput);
      if (!ok) {
        showGroupError(deliveryError, 'Вкажіть вулицю та номер будинку');
        return false;
      }
    } else if (val === '3') {
      unmarkRed(streetInput);
      unmarkRed(homeInput);
      unmarkRed(novaBoxInput);
      if (!novaInput?.value.trim()) {
        markRed(novaInput);
        showGroupError(deliveryError, 'Оберіть відділення Нової Пошти');
        return false;
      } else {
        unmarkRed(novaInput);
      }
    } else if (val === '4') {
      unmarkRed(streetInput);
      unmarkRed(homeInput);
      unmarkRed(novaInput);
      if (!novaBoxInput?.value.trim()) {
        markRed(novaBoxInput);
        showGroupError(deliveryError, 'Оберіть поштомат Нової Пошти');
        return false;
      } else {
        unmarkRed(novaBoxInput);
      }
    }

    hideGroupError(deliveryError);
    return true;
  }

  function validate() {
    let ok = true;

    if (!isPhoneValid()) {
      setError(phoneInput, 'Введіть номер телефону повністю');
      ok = false;
    } else if (!isContactConfirmed()) {
      setError(phoneInput, 'Підтвердіть номер телефону через SMS');
      ok = false;
    } else {
      clearErr(phoneInput);
    }

    const name = nameInput?.value.trim() ?? '';
    if (name.length < 2) {
      setError(nameInput, "Введіть прізвище та ім'я");
      ok = false;
    } else {
      clearErr(nameInput);
    }

    const lastname = lastnameInput?.value.trim() ?? '';
    if (lastname.length < 2) {
      setError(lastnameInput, "Введіть прізвище та ім'я");
      ok = false;
    } else {
      clearErr(lastnameInput);
    }

    const emailVal = emailInput?.value.trim() ?? '';
    if (emailVal && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailVal)) {
      setError(emailInput, 'Введіть коректний e-mail');
      ok = false;
    } else {
      clearErr(emailInput);
    }

    if (!cityInput?.value.trim()) {
      setError(cityInput, 'Введіть місто доставки');
      ok = false;
    } else {
      clearErr(cityInput);
    }

    if (!validateDelivery()) ok = false;

    const paySelected = form.querySelector('input[name="payment_method_id"]:checked');
    if (!paySelected) {
      showGroupError(payError, 'Оберіть спосіб оплати');
      ok = false;
    } else {
      hideGroupError(payError);
    }

    return ok;
  }

  function checkFormValidity() {
    const wrapper2 = g('.order-new-section__wrapper--2');
    const deliverySelected = form.querySelector('input[name="delivery_id"]:checked');
    let deliveryFieldsValid = false;

    if (deliverySelected) {
      const val = deliverySelected.value;
      if (val === '1') {
        deliveryFieldsValid = !!streetInput?.value.trim() && !!homeInput?.value.trim();
      } else if (val === '3') {
        deliveryFieldsValid = !!novaInput?.value.trim();
      } else if (val === '4') {
        deliveryFieldsValid = !!novaBoxInput?.value.trim();
      }
    }

    const isValid =
      isPhoneValid() &&
      isContactConfirmed() &&
      (nameInput?.value.trim().length ?? 0) >= 2 &&
      !!cityInput?.value.trim() &&
      !!deliverySelected &&
      deliveryFieldsValid &&
      !!form.querySelector('input[name="payment_method_id"]:checked');

    wrapper2?.classList.toggle('is-valid', isValid);
  }

  form.addEventListener('submit', (e) => {
    e.preventDefault();

    if (!validate()) {
      const firstInvalid =
        form.querySelector('[aria-invalid="true"]') ||
        form.querySelector('.message_error:not([style*="none"])');

      if (firstInvalid) {
        firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (firstInvalid.tagName === 'INPUT') firstInvalid.focus();
      }
      return;
    }

    form.submit();
  });

  [phoneInput, nameInput, emailInput, cityInput].filter(Boolean).forEach((el) => {
    el.addEventListener('blur', validate);
    el.addEventListener('input', checkFormValidity);
  });

  [streetInput, homeInput, novaInput, novaBoxInput].filter(Boolean).forEach((el) => {
    el.addEventListener('input', () => {
      validateDelivery();
      checkFormValidity();
    });
  });

  form.querySelectorAll('input[name="delivery_id"]').forEach((el) => {
    el.addEventListener('change', () => {
      validateDelivery();
      checkFormValidity();
    });
  });

  form.querySelectorAll('input[name="payment_method_id"]').forEach((el) => {
    el.addEventListener('change', () => {
      const paySelected = form.querySelector('input[name="payment_method_id"]:checked');
      if (paySelected) hideGroupError(payError);
      checkFormValidity();
    });
  });

  checkFormValidity();
})();
